import styled from 'styled-components';
import { h3Styles } from '~typography';
var Measure = styled.span.withConfig({
  displayName: "Measure",
  componentId: "sc-116hpz-0"
})(["", ""], h3Styles);
export default Measure;